/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContactRequestToJSON } from '../models/index';
import * as runtime from '../runtime';
/**
 *
 */
export class ContactApi extends runtime.BaseAPI {
    /**
     * Submit a contact form.  Stores the submission in Firestore, and notifies the resolved brand\'s own admin inbox (see `resolved_brand` below — the anonymous-visitor counterpart of `src.services.email_brand_resolution`, which requires a `User`/uid this endpoint never has).
     * Submit Contact Form
     */
    async submitContactFormV1ContactPostRaw(requestParameters, initOverrides) {
        if (requestParameters['contactRequest'] == null) {
            throw new runtime.RequiredError('contactRequest', 'Required parameter "contactRequest" was null or undefined when calling submitContactFormV1ContactPost().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        let urlPath = `/v1/contact`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ContactRequestToJSON(requestParameters['contactRequest']),
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Submit a contact form.  Stores the submission in Firestore, and notifies the resolved brand\'s own admin inbox (see `resolved_brand` below — the anonymous-visitor counterpart of `src.services.email_brand_resolution`, which requires a `User`/uid this endpoint never has).
     * Submit Contact Form
     */
    async submitContactFormV1ContactPost(requestParameters, initOverrides) {
        const response = await this.submitContactFormV1ContactPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
